import React from 'react';
import Markdown from 'markdown-to-jsx';
import classnames from 'classnames';

import renderers from './renderers';

const MarkdownRenderer = ({ content, company, customer, isComparisonPage }) => {
  if (!content) return null;

  return (
    <Markdown
      children={content}
      options={{
        forceBlock: true,
        overrides: {
          CustomerQuote: {
            component: renderers.CustomerQuote,
            props: {
              company,
              customer,
            },
          },
          code: renderers.CodeBlock,
          h1: {
            component: renderers.Heading,
            props: {
              level: 1,
            },
          },
          h2: {
            component: renderers.Heading,
            props: {
              level: 2,
              className: classnames({ 'text-center': isComparisonPage }),
            },
          },
          h3: {
            component: renderers.Heading,
            props: {
              level: 3,
            },
          },
          h4: {
            component: renderers.Heading,
            props: {
              level: 4,
            },
          },
          p: renderers.Paragraph,
          a: renderers.Link,
          strong: renderers.Strong,
          blockquote: renderers.Blockquote,
          ol: renderers.OrderedList,
          ul: renderers.UnorderedList,
          li: renderers.ListItem,
          img: {
            props: {
              className: 'h-auto max-w-full w-auto block rounded my-6 md:my-12',
            },
          },
          hr: renderers.HorizontalRule,
          table: {
            component: renderers.Table,
            props: {
              className: classnames({
                'table-auto w-full mt-4 text-gray-800': isComparisonPage,
              }),
            },
          },
          thead: renderers.THead,
          th: {
            component: renderers.TableHeader,
            props: {
              className: classnames({
                'border border-gray-200 first:w-1/2 even:bg-purple-100 p-4': isComparisonPage,
              }),
            },
          },
          td: {
            component: isComparisonPage
              ? renderers.ComparisonTableD
              : renderers.TableD,
            props: {
              className: classnames({
                'border border-gray-200 text-center first:w-1/2 first:text-left even:bg-purple-100 p-4': isComparisonPage,
              }),
            },
          },
        },
      }}
    />
  );
};

export default MarkdownRenderer;
